import { Dispatch } from 'redux';
import { ORGANIZER_QUESTIONS_FORM_NAME } from '../constants';
import { cleanFormData } from '../containers/checkout/utils';
import { FormData } from '../models/survey';
import { getFormValues } from '../selectors/forms';
import { getOrderId } from '../selectors/order/typedOrderSelectors';
import { getSurvey } from '../selectors/survey';
import { CheckoutState } from '../state';
import {
    getRateFromOrganizerQuestionsAnswered,
    getSurveyAnswers,
    removeCopyBillingInfoField,
} from '../utils/surveys';
import { updateOrderWithOptionalOrganizerQuestions } from './order/survey';

export const submitOptionalOrganizerQuestionsForm =
    (formData: FormData, skipErroredAnswers: boolean) =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        const state = getState();
        const survey = getSurvey(state);
        const orderId = getOrderId(state);

        const formDataToSubmit =
            formData ?? getFormValues(state, ORGANIZER_QUESTIONS_FORM_NAME);
        const formDataCleaned = cleanFormData(formDataToSubmit, survey);
        const surveyAnswers = getSurveyAnswers(
            removeCopyBillingInfoField(formDataCleaned),
        );
        const optionalQuestionAnswerRatio =
            getRateFromOrganizerQuestionsAnswered(
                survey,
                formData,
                ORGANIZER_QUESTIONS_FORM_NAME,
            );

        await dispatch(
            updateOrderWithOptionalOrganizerQuestions(
                orderId,
                surveyAnswers,
                skipErroredAnswers,
                optionalQuestionAnswerRatio,
            ),
        );
    };
